import { Alert } from '@mui/material';
import Pagination from '@mui/material/Pagination';
import { styled } from '@mui/material/styles';

const StyledPagination = styled(Pagination)({
    root: {
        display: 'flex',
        justifyContent: 'center'
    }
});

const StyledAlertAnchor = styled('a')(({ theme }) => ({
    color: theme.palette.primary.main,
    fontWeight: 'bold',
    textDecoration: 'underline',
    cursor: 'pointer'
}));

const StyledAlert = styled(Alert)({
    root: {
        marginBottom: '5px'
    }
}) as typeof Alert;

const StyledButtonContainer = styled('div')({
    marginTop: '30px'
});

export { StyledAlert, StyledAlertAnchor, StyledPagination, StyledButtonContainer };
